<span class="navigation-container" *ngIf="!isMobile">
   <img [src]="builderInteractionsService?.companyInfo?.value?.branding?.cache_icon_big || 'assets/images/logos/logo_placeholder.png'" />
    </span>
@if (isMobile && showAsDialog) {
  <span class="db-main-header-content">
    <div class="db-header-back-button" (click)="headerBack()">
      <i class="db-icon db-icon-ds-arrow-small"></i>
      <span>back</span>
    </div>
  </span>
}

<ng-container [ngSwitch]="step">
  <db-create-ai-assistant-start-view
    *ngSwitchCase="'startView'"
    [isOnboarding]="!!isOnboarding"
    [showThemeNotification]="showThemeNotification"
    [themeIsActive]="tenWebTheme?.active"
    [loading]="themeLoading"
    [user]="user"
    [website]="website" [builderPlugin]="builderPlugin" [elementorPlugin]="elementorPlugin"
    (start)="onStart()"
    (activateTheme)="activateTenWebTheme()"
  ></db-create-ai-assistant-start-view>
  <db-sign-up-with-hubspot
    *ngSwitchCase="'signUpHubspot'"
    [email]="email"
    (close)="showUpgrade()"
    (next)="email = $event; step = 'companyType'">
    <!--TODO website type change-->
  </db-sign-up-with-hubspot>
    <db-create-ai-assistant-choose-website-type
      *ngSwitchCase="'chooseWebsiteType'"
      [fromStartAIPage]="fromStartAIPage"
      [fromDomains]="fromDomains"
      [isFromGenerate]="isFromGenerate"
      [signUpWithHubspot]="signUpWithHubspot"
      [forRecreateFirstTime]="forRecreateFirstTime"
      [showAsDialog]="showAsDialog"
      [loading]="loadingFirstNext"
      (close)="showUpgrade()"
      (back)="(!!signUpWithHubspot && !user) ? step = 'signUpHubspot' : goToPrevPage()"
      (next)="chooseWebsiteType($event, true)"
    ></db-create-ai-assistant-choose-website-type>
  <db-create-ai-assistant-company-type
    *ngSwitchCase="'companyType'"
    [user]="user"
    [hasEcommerceService]="true"
    [isOnboarding]="isOnboarding"
    [hideBackButton]="hideBackButton"
    [isFirstStep]="!!isOnboarding || !!isFromGenerate"
    [selectedCompanyType]="encodedCompanyData?.industry_name || params?.business_type"
    [selectedBusinessCategory]="params?.business_category"
    [companyTypes]="companyTypes"
    [nextIsTemplate]="nextIsTemplate"
    (back)="setDefault()"
    (categoryType)="selectedCategoryType = $event"
    (companyTypeSelected)="setCompanyType($event)"
  ></db-create-ai-assistant-company-type>
  <db-create-ai-assistant-store-type
    *ngSwitchCase="'storeType'"
    [isOnboarding]="isOnboarding"
    [hideBackButton]="hideBackButton"
    [isFirstStep]="!!isOnboarding || !!isFromGenerate"
    [selectedStoreType]="encodedCompanyData?.industry_name || params?.business_type"
    [selectedBusinessCategory]="params?.business_category"
    [storeTypes]="storeTypes"
    (back)="setDefault()"
    (categoryType)="selectedCategoryType = $event"
    (storeTypeSelected)="setCompanyType($event, true)"
  ></db-create-ai-assistant-store-type>
  <!--<db-create-ai-assistant-themes
    *ngSwitchCase="'companyTheme'"
    [selectedTheme]="$any(params?.theme_id)"
    [themes]="themes"
    (back)="step = 'companyType'"
    (onThemeSelect)="setTheme($event)">
  </db-create-ai-assistant-themes>-->
  <db-create-ai-assistant-template-select
    *ngSwitchCase="'template'"
    [imagesLoading]="imagesLoading"
    [selectedTemplate]="selectedTemplate !== '' ? selectedTemplate : $any(params?.template_id)"
    [templates]="templates"
    [selectedTheme]="selectedTheme ? selectedTheme : ($any(params?.theme_id) || (themes && themes[0] && themes[0]?.id))"
    [themes]="themes"
    [theme]="$any(params?.theme_id)"
    [currentStep]="current"
    [stepsLength]="data?.length"
    (back)="step = (isEcommerce ? 'storeType' : 'companyType'); selectedTemplate = null; getBackFromSite(true)"
    (onThemeSelect)="setTheme($event)"
    (onTemplateSelect)="setTemplate($event)"
    (setTheme)="selectedTheme = $event"
    (setTemplate)="selectedTemplate = $event">
  </db-create-ai-assistant-template-select>
  <db-create-ai-assistant-form-view
    *ngSwitchCase="'form'"
    [currentStep]="current"
    [frontUrl]="frontUrl"
    [hasTemplatesPage]="templates?.length > 1"
    [websiteId]="websiteId"
    [signUpWithHubspot]="signUpWithHubspot"
    [previousStep]="current - 1"
    [stepsLength]="data?.length"
    [formGroupData]="data[current]"
    [oldFormData]="params"
    [user]="user"
    [isEcommerce]="selectedCategoryType === 'ecommerce'"
    [recreationProcess]="recreationProcess"
    [showHigDemandNotice]="showHigDemandNotice"
    [isOnboarding]="!!isOnboarding"
    [isFromGenerate]="!!isFromGenerate"
    [forRecreateFirstTime]="!!forRecreateFirstTime"
    [recreationFinished]="!!recreationFinished"
    [fromLanding]="!!encodedCompanyData.site_description"
    (blogType)="blogTemplate = true"
    (next)="next($event)"
    (back)="getBackFromSite(); back($event)">
  </db-create-ai-assistant-form-view>
  <!--<db-create-ai-assistant-sign-up *ngSwitchCase="'signUp'"
              (next)="next($event)"
  ></db-create-ai-assistant-sign-up>-->
  <db-create-ai-assistant-finalize
    *ngSwitchCase="'finalize'"
    [blogType]="blogTemplate"
    [isEcommerce]="selectedCategoryType === 'ecommerce'"
    [recreationFinished]="recreationFinished">
  </db-create-ai-assistant-finalize>
  <db-loading-screen *ngIf="!!loading" [pageBlocker]="true"></db-loading-screen>
</ng-container>

